import { useState, useEffect } from 'react';
import { transformRedactedContent } from '../utils/contentTransform';

export const useRedactionMode = ({ mode, htmlContent, text, editable }) => {
  const [displayContent, setDisplayContent] = useState('');

  useEffect(() => {
    if (!editable) {
      const transformed = transformRedactedContent(htmlContent || text, mode);
      setDisplayContent(transformed);
    }
  }, [mode, htmlContent, text, editable]);

  const getCurrentDisplayContent = () => {
    if (editable) {
      return htmlContent || text;
    } else {
      return transformRedactedContent(htmlContent || text, mode);
    }
  };

  return {
    displayContent,
    getCurrentDisplayContent
  };
};
